import { createContext, useContext } from 'react';
import type { TwilioPhone } from './useTwilioPhone';

/**
 * One softphone for the whole module. Two `useTwilioPhone` calls would build two
 * Twilio Devices on the same identity, and Twilio rings every device registered
 * under an identity — so the call bar and the thread's Call button share this
 * instead of each holding their own.
 *
 * Null when the provider is absent, which the preview route relies on: the
 * module renders complete, minus a phone.
 */
export const PhoneContext = createContext<TwilioPhone | null>(null);

export const usePhone = (): TwilioPhone | null => useContext(PhoneContext);
